import React from 'react'
import { Box } from '@mui/material'
import type { SxProps, Theme } from '@mui/material'

export const APP_DRAWER_WIDTH = 520
// Neutral off-white body sitting behind the white section cards. Shared by
// every app drawer so the family reads consistently; nudged a touch warmer/
// less blue than the old #F6F8FB to pair with the soft-teal section headers.
export const APP_DRAWER_BG = '#F4F6F7'
export const APP_DRAWER_SHADOW = '-8px 0 24px rgba(15,23,42,0.08)'

export interface AppDrawerShellProps {
  children?: React.ReactNode
  bg?: string
  sx?: SxProps<Theme>
}

const AppDrawerShell: React.FC<AppDrawerShellProps> = ({ children, bg = APP_DRAWER_BG, sx }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      bgcolor: bg,
      ...sx,
    }}
  >
    {children}
  </Box>
)

export default AppDrawerShell
